import { render, staticRenderFns } from "./CompanyPreviewSp.vue?vue&type=template&id=b987d390"
import script from "./CompanyPreviewSp.vue?vue&type=script&lang=js"
export * from "./CompanyPreviewSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports